import { PrintText as e } from "./components/index.es.js";
import { actionHandler as t } from "./lib/actionHandler.es.js";
import { TextRole as n } from "./components/TextRole.es.js";
import { Text as r } from "./components/Text.es.js";
import { normalizePrintText as i } from "./lib/normalizePrintText.es.js";
import { FileTypeCornerIcon as a } from "lucide-react";
import { jsx as o } from "react/jsx-runtime";
//#region lib/PrintText/index.tsx
var s = (s) => ({
	class: "block",
	name: "tt/print-text",
	options: s,
	actions: [{
		name: "tt/print-text",
		title: "Print-text",
		tool: () => /* @__PURE__ */ o(a, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: t,
		visibility: () => [
			!0,
			!0,
			!1
		]
	}],
	componentEntry: {
		class: "block",
		component: e,
		constraints: { normalizeNode: i },
		children: [{
			type: "text",
			class: "text",
			component: r,
			constraints: {
				min: 1,
				max: 1
			}
		}, {
			type: "role",
			class: "text",
			component: n,
			constraints: {
				min: 1,
				max: 1
			}
		}]
	}
});
//#endregion
export { s as PrintText };
